import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard, FeatureGuard } from '@app/guards';
import { HireEmployee } from '@settings/meta/module-feature-permissions.meta';
import { CandidateIndexView, OfferLetterStoreView, CandidateShowView } from '@offer-letter/views';
import { FeatureFlag } from '@app/enums';
import { OfferLetterResolver } from './offer-letter.resolver';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'candidates',
        pathMatch: 'full',
        data: {
            permission: HireEmployee.permissions,
            feature: { flags: [FeatureFlag.offerLetters] },
        },
    },
    {
        path: 'candidates',
        component: CandidateIndexView,
        canActivate: [PermissionGuard, FeatureGuard],
        data: {
            permission: HireEmployee.permissions,
            feature: { flags: [FeatureFlag.offerLetters] },
        },
    },
    {
        path: 'new',
        component: OfferLetterStoreView,
        canActivate: [PermissionGuard, FeatureGuard],
        data: {
            permission: HireEmployee.permissions,
            feature: { flags: [FeatureFlag.offerLetters] },
        },
    },
    {
        path: ':offerLetter/revise',
        component: OfferLetterStoreView,
        canActivate: [PermissionGuard, FeatureGuard],
        data: {
            permission: HireEmployee.permissions,
            feature: { flags: [FeatureFlag.offerLetters] },
        },
        resolve: {
            models: OfferLetterResolver,
        },
    },
    {
        path: 'candidates/:candidate',
        component: CandidateShowView,
        canActivate: [PermissionGuard, FeatureGuard],
        data: {
            permission: HireEmployee.permissions,
            feature: { flags: [FeatureFlag.offerLetters] },
        },
        resolve: {
            models: OfferLetterResolver,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class OfferLetterRouterModule {}
